// extracted by mini-css-extract-plugin
export default {"tableFormItem":"PrintOptionsCostFieldTable_tableFormItem__3idgQ","footer":"PrintOptionsCostFieldTable_footer__+6WB0"};